<template>
  <div id="module" class="ClientMaster">
    <el-container>
      <el-header class="CM-Header">
        <div class="CM-Top">
          <div class="left">心理危机预防干预系统</div>
          <div class="right">
            <span class="el-icon-c-scale-to-original"></span>
          </div>
          <div class="ml-right">
            <div class="imgHead"><img :src="imageUrl" /></div>
            <div class="userName">{{ UserInfo.UserName }}</div>
            <el-popover placement="bottom-end" width="80" trigger="hover" class="setting">
              <ul id="menu" class="headermenu">
                <a>
                  <li class="headermenu__item" @click="goBack()">重新登录</li>
                </a>
              </ul>
              <div slot="reference" class="el-icon-setting"></div>
            </el-popover>
          </div>
        </div>
        <div class="CM-MenuLList">
          <ul class="MenuLList">
            <li v-for="(item, index) in nav_list" :key="item.MenuID"
              :class="(selectedPath == '' && index == 0) || selectedPath == item.LinkURL ? 'yesSelect' : 'noSelect'"
              @click="gotoUrl(item)">
              {{ item.MenuName }}
            </li>
          </ul>
        </div>
      </el-header>
      <el-main class="CM-Main">
        <router-view />
      </el-main>
    </el-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      RoleID:sessionStorage.getItem('RoleID'),
      UserInfo: localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo"))
        : {},
      imageUrl:
        this.Global.headPhoto == undefined ||
          this.Global.headPhoto == null ||
          this.Global.headPhoto == ""
          ? "../../img/manHead.png"
          : this.Global.headPhoto,
      selectedPath: "",
      nav_list: [],
    };
  },
  mounted() {
    let _this = this;
    this.$Http_Post("User/GetRoleMenu",{RoleID:this.RoleID}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        _this.nav_list = res.Data;
        if (_this.nav_list.length > 0) {
          for (let i = 0; i < _this.nav_list.length; i++) {
            if (_this.nav_list[i].LinkURL != null)
              _this.nav_list[i].LinkURL = '/Client' + _this.nav_list[i].LinkURL.substring(
                _this.nav_list[i].LinkURL.lastIndexOf("/"),
                _this.nav_list[i].LinkURL.length
              );
          }
        }
      }else if(res.Code==208){
        this.$router.push('/login');
      }
    });
  },
  methods: {
    goBack() {
      this.$router.push("/ClientLogin");
    },
    gotoUrl(item) {
      this.selectedPath = item.LinkURL;
      this.$router.push(this.selectedPath);
    },
  },
};
</script>

<style scoped>
.CM-Header {
  height: 103px !important;
  padding: 0px !important;
  margin: 0px !important;
}

.CM-Main {
  background-image: url("../../assets/img/client/img_body_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.CM-MenuLList {
  height: 53px;
  background: rgba(21, 47, 71, 1);
  list-style: none;
}

.CM-MenuLList .MenuLList li {
  width: 208px;
  height: 60px;
  text-align: center;
  padding-top: 4px;
  font-size: 16px;
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.CM-MenuLList .MenuLList .yesSelect,
.CM-MenuLList .MenuLList li:hover {
  color: rgba(255, 241, 112, 1);
  background-image: url("../../assets/img/client/icon_topnav_selected.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.CM-MenuLList .MenuLList .noSelect {
  color: rgba(74, 216, 232, 1);
  background-image: url("../../assets/img/client/icon_topnav_default.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.CM-Top {
  widows: 100%;
  height: 50px;
  line-height: 50px;
  background-image: url("../../assets/img/client/icon_topnav_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  mix-blend-mode: normal;
}

.CM-Top .left {
  float: left;
  margin-left: 30px;
  height: 50px;
  line-height: 50px;
  color: rgba(122, 231, 255, 1);
  font-size: 24px;
}

.CM-Top .ml-right {
  width: 200px;
  height: 50px;
  line-height: 50px;
  margin-right: 1.5%;
  float: right;
}

.CM-Top .ml-right .imgHead {
  float: right;
}

.CM-Top .ml-right .userName {
  float: right;
  margin-right: 10px;
}

.CM-Top .ml-right .setting {
  float: right;
  margin-right: 10px;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
  margin-top: 10px;
  font-size: 20px;
  color: rgba(96, 137, 150, 1);
  cursor: pointer;
}

.CM-Top .ml-right {
  color: rgba(64, 245, 255, 1);
}

.CM-Top .ml-right img {
  width: 30px;
  height: 30px;
  border-radius: 15px;
  background-color: aqua;
  margin-top: 10px;
}

.CM-Top .right {
  width: 60px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 24px;
  color: rgba(111, 138, 163, 1);
  float: right;
}

.CM-Top .right span {
  cursor: pointer;
}

.headermenu__item {
  position: relative;
  display: block;
  line-height: 20px;
  text-align: center;
  padding: 5px;
  color: #60666c;
  z-index: 99999999999;
}

.headermenu__item:hover {
  background-color: rgba(111, 138, 163, 1);
  cursor: pointer;
  color: rgba(18, 41, 61, 1);
  color: rgba(132, 219, 211, 1);
}
</style>